import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLock, FiEdit3, FiGlobe, FiHome } = FiIcons;

const steps = [
  {
    icon: FiLock,
    title: '1. Claim Your Trade',
    description: "Strict exclusivity. If you're the plumber on this mailer, no other plumber gets in. One trade per category — total dominance in your niche."
  },
  {
    icon: FiEdit3,
    title: '2. Design Help Included',
    description: "We design your 2.6″ × 3.75″ mailer ad and matching business cards — print-ready, professional, built to convert homeowners into calls."
  },
  {
    icon: FiGlobe,
    title: '3. Your Landing Page Goes Live',
    description: "Your QR code links to a Mailbox Digital landing page with your services, photos, contact form, and phone number — ready before your first drop."
  },
  {
    icon: FiHome,
    title: '4. Get on Their Fridge',
    description: "5,000 homes receive the mailer. 250 business cards go in your pocket. Your name stays in front of homeowners every time something needs fixing."
  }
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 bg-brand-cream border-t-8 border-brand-yellow">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-4xl md:text-6xl font-black text-brand-brown mb-6 uppercase tracking-tighter italic">How It Works</h2>
          <p className="text-xl text-brand-brown/70 font-bold leading-relaxed">
            We build a co-op Home Services Directory that West Valley homeowners keep on their fridge and reach for the moment something needs fixing.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group"
            >
              <div className="w-20 h-20 bg-white shadow-xl border-4 border-brand-brown/5 rounded-[2rem] flex items-center justify-center text-brand-blue text-4xl mb-8 group-hover:bg-brand-blue group-hover:text-white transition-all duration-500 group-hover:-rotate-6">
                <SafeIcon icon={step.icon} />
              </div>
              <h3 className="text-2xl font-black text-brand-brown mb-4 uppercase tracking-tight">{step.title}</h3>
              <p className="text-brand-brown/70 leading-relaxed font-bold">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
